export default [
    {
        path: '/',
        name: '001-0',
        label: '首页',
        component: resolve => require(['./pages/welcome'], resolve)
    },
   // 首页
    {
        path: '/welcome',
        name: '001',
        label: '介绍',
        component: resolve => require(['./pages/welcome'], resolve)
    },
    {
        path: '/reg',
        name: '001-1',
        label: '注册',
        // meta: {auth: false},
        component: resolve => require(['./pages/reg'], resolve)
    },
    {
        path: '/login',
        name: '001-2',
        label: '登陆',
        // meta: {auth: false},
        component: resolve => require(['./pages/login'], resolve)
    },
    // 商城
    {
        path: '/mall/mall',
        name: '002-1',
        label: '现货商城',
        component: resolve => require(['./pages/mall/mall'], resolve)
    },
    {
        path: '/mall/mall_item',
        name: '002-3',
        label: '商品详情',
        component: resolve => require(['./pages/mall/mall_item'], resolve)
    },
    // 供应资源
    {
        path: '/supplier/futures',
        name: '003-1',
        label: '全球木材采购中心',
        component: resolve => require(['./pages/supplier/futures'], resolve)
    },
    {
        path: '/supplier/supply',
        name: '003-2',
        label: '供应资源',
        component: resolve => require(['./pages/supplier/supply'], resolve)
    },
    // 供应链
    {
        path: '/support/trust',
        name: '004-1',
        label: '委托找货',
        component: resolve => require(['./pages/support/trust'], resolve)
    },
    {
        path: '/support/finance',
        name: '004-2',
        label: '金融',
        component: resolve => require(['./pages/support/finance'], resolve)
    },
    {
        path: '/support/logistics',
        name: '004-3',
        label: '物流',
        component: resolve => require(['./pages/support/logistics'], resolve)
    },
    {
        path: '/support/logistics_more',
        name: '004-3-1',
        label: '物流找车信息',
        component: resolve => require(['./pages/support/logistics_more'], resolve)
    },
    {
        path: '/support/route_more',
        name: '004-3-2',
        label: '物流固定路线',
        component: resolve => require(['./pages/support/route_more'], resolve)
    },
    {
        path: '/support/warehouse',
        name: '004-4',
        label: '仓库',
        component: resolve => require(['./pages/support/warehouse'], resolve)
    },
    // {
    //     path: '/support/software',
    //     name: '004-5',
    //     label: '软件',
    //     component: resolve => require(['./pages/support/software'], resolve)
    // },
    // 购物车
    {
        path: '/member/cart',
        name: '005-2',
        label: '购物车',
        component: resolve => require(['./pages/member/cart'], resolve)
    },
    // 订单列表
    {
        path: '/member/order-list',
        name: '005-3',
        label: '订单列表',
        component: resolve => require(['./pages/member/order-list'], resolve)
    },
    // 订单
    {
        path: '/member/order/:pk',
        name: '005-4',
        label: '订单详情',
        component: resolve => require(['./pages/member/order'], resolve)
    },
    {
        path: '/member/info',
        name: '005-6',
        label: '账户首页',
        component: resolve => require(['./pages/member/info'], resolve)
    },
    {
        path: '/member/user-manage',
        name: '005-7',
        label: '用户管理',
        component: resolve => require(['./pages/member/user-manage'], resolve)
    },
    {
        path: '/member/my-logistics',
        name: '005-8',
        label: '木马物流-我的找车',
        component: resolve => require(['./pages/member/my-logistics'], resolve)
    },
    {
        path: '/member/my-trust',
        name: '005-9',
        label: '我的找货',
        component: resolve => require(['./pages/member/my-trust'], resolve)
    },
    {
        path: '/member/futures-inquiry',
        name: '005-10',
        label: '期货询价',
        component: resolve => require(['./pages/member/futures-inquiry'], resolve)
    },
    {
        path: '/member/supplylist',
        name: '005-11',
        label: '供应资源-关注列表',
        component: resolve => require(['./pages/member/supplylist'], resolve)
    },
    {
        path: '/member/my-trustinquiry/:pk',
        name: '005-14',
        label: '找货报价',
        component: resolve => require(['./pages/member/my-trustinquiry'], resolve)
    },
    {
        path: '/member/my-logisticsinquiry/',
        name: '005-15',
        label: '木马物流-找车报价',
        component: resolve => require(['./pages/member/my-logisticsinquiry'], resolve)
    },
    {
        path: '/member/my-routeinquiry',
        name: '005-16',
        label: '木马物流-固定线路报价',
        component: resolve => require(['./pages/member/my-routeinquiry'], resolve)
    },
    {
        path: '/company/company_list',
        name: '006',
        label: '经销商列表',
        component: resolve => require(['./pages/company/company_list'], resolve)
    },
    {
        path: '/company/company_detail',
        name: '006-1',
        label: '经销商详情',
        component: resolve => require(['./pages/company/company_detail'], resolve)
    },
    {
        path: '/news/news',
        name: '007',
        label: '行业资讯',
        component: resolve => require(['./pages/news/news'], resolve)
    },
    {
        path: '/news/news_detail',
        name: '007-1',
        label: '资讯详情',
        component: resolve => require(['./pages/news/news_detail'], resolve)
    },
    // 其他
    {
        path: '*', // 其他页面，强制跳转到登录页面
        name: '999',
        redirect: '/'
    }
]



// WEBPACK FOOTER //
// ./src/routes.js